import { Fragment } from "preact";
import Center from "../../../components/center";
import Editorial from "../../../components/editorial";
import Head from "../../../components/head";
import Hero from "../../../components/hero";
import Ligature from "../../../components/ligature";
import CandidateBio from "../../../components/candidate-bio";
import namedRoutes from "../../../settings/routes";

const candidate = {
  name: "Connie Wan",
  since: "TBD",
  email: "ConnieKlahanie@gmail.com",
  photo: "/images/candidates/connie-wan.jpg",
};

const pageTitle = `${candidate.name} - Klahanie.info`;

const questions = null;

const CandidatePage = () => (
  <Editorial>
    <Head title={pageTitle} />
    <Hero background="/images/backgrounds/forest-path.jpg">
      <h1>
        <span style="font-size: 0.5em; font-weight: 400; display: block; margin-bottom: 0.25em; text-transform: none;">
          Vote for{" "}
        </span>
        <Ligature>{candidate.name}</Ligature>
      </h1>
      <h2 style="font-size: 1.1em; font-weight: 400;">
        <span>Candidate for Klahanie Board of Directors</span>
      </h2>
    </Hero>
    <div>
      <Center>
        <CandidateBio
          img={candidate.photo}
          name="Connie Wan, Ph.D., J.D."
          since={candidate.since}
          email={candidate.email}
          questions={questions}
        >
          <Fragment>
            <h2>Personal</h2>
            <p>
              Klahanie is the place I proudly call home. I raised my family
              here: my son attended Challenger, Beaver Lake, and Skyline, a true
              Klahanie kid. Each week, as I walk along Klahanie Boulevard, bike
              through the neighborhood, or run around Yellow Lake Trail, the
              friendly nods, smiling faces, and lighthearted hellos remind me
              what makes this community special.
            </p>

            <h2>Community Service</h2>
            <p>
              I have been actively involved in Klahanie volunteering and HOA
              service for over a decade, including:
            </p>
            <ul>
              <li>Prior Board of Directors experience</li>
              <li>Finance &amp; Operations Committee</li>
              <li>Architecture Committee</li>
              <li>Fines Committee</li>
              <li>Neighborhood Watch program</li>
            </ul>
            <p>
              This experience has given me a deep understanding of how our
              association operates and what it takes to serve homeowners
              effectively.
            </p>

            <h2>Professional Background</h2>
            <p>
              I am a practicing attorney and the founder and CEO of Seattle
              Gummy Company, with a Ph.D. in pharmaceutical sciences. My
              professional experience includes strategic planning, operational
              oversight, financial stewardship, and long-term risk management.
              An active legal practice provides a strong foundation in
              governance, contracts, compliance, and fiduciary decision-making.
            </p>
            <p>
              These skills translate directly to HOA leadership, where the board
              must balance competing priorities, manage significant budgets,
              oversee contracts, and make decisions that affect every
              homeowner's investment.
            </p>

            <h2>Board Service</h2>
            <p>
              As a member of the current Klahanie Board of Directors, I have:
            </p>
            <ul>
              <li>
                Supported the 2025 bylaw amendments restoring homeowner approval
                for major spending and borrowing decisions
              </li>
              <li>
                Advocated for holding HOA fees flat while maintaining adequate
                reserves
              </li>
              <li>
                Supported pausing the Mountainview project to conduct proper
                facility assessments
              </li>
              <li>
                Worked to ensure transparent, thorough board discussions on
                budget and major projects
              </li>
            </ul>

            <h2>Why I'm Running</h2>
            <p>
              I bring a balanced and practical approach to governance, grounded
              in fiscal responsibility. Homeowners are the true owners of
              Klahanie. I deeply respect the fiduciary duty entrusted to the
              board: to safeguard the HOA's financial health, protect shared
              assets, and ensure sustainable, responsible, and transparent
              decision-making while respecting individual property rights.
            </p>
            <p>
              Above all, I believe the board exists to serve the community, not
              to govern it. My goal is thoughtful stewardship, transparency, and
              collaborative problem-solving in support of Klahanie today and for
              years to come.
            </p>
          </Fragment>
        </CandidateBio>
      </Center>
    </div>
  </Editorial>
);

export default CandidatePage;
